import React from 'react'
import { useTheme } from '@emotion/react'
import Year from 'components/year'
import Link from 'components/link'
import classNames from 'classnames'

export default function Legal({ style, className }){
    const theme = useTheme()
    
    return(
        <div
            style={{
                fontSize: 12,
                ...style
            }}
            className={classNames(
                'd-flex j-between',
                className
            )}
            css={{
                [theme.queries.lg]: {
                    flexDirection: 'column',
                    gap: 40,
                }
            }}
        >
            <p>&copy; <Year /> inMusic, LLC. All Rights Reserved.</p>

            <div className='d-flex wrap' style={{ rowGap: 0, columnGap: 8 }}>
                <Link to='/dealers'>
                    Dealers
                </Link>
                <span>|</span>
                <Link to='/privacy-policy'>
                    Privacy
                </Link>
                <span>|</span>
                <Link to='/terms-of-use'>
                    Terms of Use
                </Link>
                <span>|</span>
                <Link href='https://cdn.inmusicbrands.com/inmusic/doc/UK_Modern_Slavery_Act_Statement.pdf' arrow={false}>
                    Modern Slavery Act
                </Link>
            </div>
        </div>
    )
}